import { Component, Input, OnInit,ViewEncapsulation } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import {RouterModule, Router} from '@angular/router';
import { CommonModule } from '@angular/common';
import { StorageService } from '../../services/storage.service';
import { EmittersService } from '../../services/emitters.service';
import { UserRoles } from '../../constants/constants';
import { PipesModule } from '../../pipes/pipes.module';
import { HelperService } from '../../services/helper.service';
@Component({
  selector: 'app-heading',
  standalone: true,
  imports: [InputSwitchModule,ButtonModule, FormsModule, RouterModule, BreadcrumbModule, DividerModule, CommonModule, PipesModule],
  templateUrl: './heading.component.html',
  styleUrl: './heading.component.scss',
})
export class HeadingComponent implements OnInit {
  items: any;
  @Input() title: string = '';
  @Input() showToggle?: boolean = false;
  @Input() isbreadcrumb?: boolean = true;
  @Input() isReviewer?: boolean = false;
  @Input() button?: any;
  @Input() extraButton?: any;
  @Input() extraButton2?: any;
  @Input() breadcrumbTitleOptions: any = [];
  checked: boolean = false;
  showCurrentUserProjects = true;
  userRole: string = '';
  selectedTenant: any = null;

  constructor(
    private storageService: StorageService,
    private emitterService: EmittersService,
    public helperService :HelperService,
    private router: Router
  ) { }

  onButtonClick(button: any): void {
    if (button.queryParams && Object.keys(button.queryParams).length) {
      this.router.navigate([button.url], { queryParams: button.queryParams });
    } else {
      this.router.navigateByUrl(button.url);
    }
  }

  ngOnInit(): void {
    let breadcrumbInitialValue = 'Project';
    if (this.router.url.startsWith('/client/jobs')) {
      breadcrumbInitialValue = 'Job';
    }
    this.userRole = this.storageService.getCookieValueByKey('role');
    if(this.button && !this.button.icon){
      this.button.icon = 'add';
    }

    let initialValue = 'Project';  
    if (this.router.url.startsWith('/client/jobs')) {
      initialValue = 'Job';
    } 
    if(UserRoles.reviewer === this.userRole){
      this.selectedTenant = this.storageService.getTenant();
      if(this.selectedTenant){
        initialValue = this.selectedTenant?.firm?.name || '';
      }
    }
    
    if(this.breadcrumbTitleOptions && this.breadcrumbTitleOptions.length){
      this.breadcrumbTitleOptions.unshift({
        label: initialValue
      });
      this.items = this.breadcrumbTitleOptions;
    } else {
      this.items = [
        { label: initialValue }, 
        { label: this.title?.split(' ')[0] }, 
        { label: 'Details' }, 
      ];
    }



    this.initializeState();
  }

  initializeState(){
    const showCurrentUserProjects = this.storageService.getCookieValueByKey('showCurrentUserProjects'); 
    this.showCurrentUserProjects = !!(showCurrentUserProjects && showCurrentUserProjects === 'true');
  }

  onMyProjectToggleSwitch() {
    this.storageService.setCookieValue('showCurrentUserProjects',  this.showCurrentUserProjects);
    this.emitterService.myProjectEmitter.emit(this.showCurrentUserProjects)
  }
}
